import { getStorage } from '@/plugins/store';
export default {
  created() {
    this.getBaseInfo();
  },
  data() {
    return {
      projectInfo: null
    };
  },
  methods: {
    getBaseInfo() {
      this.projectInfo = getStorage('projectBaseData');
      console.log('基础配置信息', this.projectInfo);
    }
  }
};